import React, { useEffect, useState } from 'react';
import PastVisitDrawerShell from '@/components/PastVisitDrawerShell';
import { patientPortalApi } from '../api/patientPortal.api';

/** Patient portal past-visit drawer — same Rx table as doctor's drawer. */
export default function PatientPastVisitDrawer({ consultationId, title, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!consultationId) return undefined;
    let cancelled = false;
    setLoading(true);
    setError(null);
    patientPortalApi.visitDetail(consultationId)
      .then((d) => { if (!cancelled) { setData(d); setLoading(false); } })
      .catch((e) => {
        if (!cancelled) {
          setError(e?.response?.data?.detail || 'Failed to load visit');
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [consultationId]);

  return (
    <PastVisitDrawerShell
      title={title || 'Visit details'}
      onClose={onClose}
      data={data}
      loading={loading}
      error={error}
      testId="patient-past-visit-drawer"
      headerClass="bg-gradient-to-r from-[#FFF7ED] to-white"
    />
  );
}
